// Author Lin
// Date 2021-11-18 14:12:13

class MintalMesPrdFieldOpcConfig {
constructor({
        id = null,
        eocId = '',
        eocName = '',
        locationId = '',
        locationName = '',
        furnaceId = '',
        furnaceName = '',
        entityName = '',
        fieldName = '',
        fieldDescription = '',
        upperLimit = '',
        lowerLimit = '',
        remark = ''}
= {}) {
    this.id = id;
    this.eocId = eocId;
    this.eocName = eocName;
    this.locationId = locationId;
    this.locationName = locationName;
    this.furnaceId = furnaceId;
    this.furnaceName = furnaceName;
    this.entityName = entityName;
    this.fieldName = fieldName;
    this.fieldDescription = fieldDescription;
    this.upperLimit = upperLimit;
    this.lowerLimit = lowerLimit;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdFieldOpcConfig();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocId',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.eocId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eocName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.eocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.locationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'furnaceId',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.furnaceId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.furnaceName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'entityName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.entityName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fieldName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.fieldName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fieldDescription',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.fieldDescription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'upperLimit',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.upperLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'lowerLimit',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.lowerLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    eocIdFilter : '',
    eocNameFilter : '',
    locationIdFilter : '',
    locationNameFilter : '',
    furnaceIdFilter : '',
    furnaceNameFilter : '',
    entityNameFilter : '',
    fieldNameFilter : '',
    fieldDescriptionFilter : '',
    upperLimitFilter : '',
    lowerLimitFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'eocNameFilter',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.filter.eocName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"eocId":"id"}'
                }
        },
        {
        key: 'locationNameFilter',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.filter.locationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                }
        },
        {
        key: 'furnaceNameFilter',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.filter.furnaceName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'furnaceName'
            ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                }
        },
        {
        key: 'entityNameFilter',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.filter.entityName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fieldNameFilter',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.filter.fieldName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fieldDescriptionFilter',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.filter.fieldDescription',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'eocName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.eocName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"eocId":"id"}'
                }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.locationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.furnaceName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'furnaceName'
            ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                }
        },
        {
        key: 'entityName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.entityName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fieldName',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.fieldName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'fieldDescription',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.fieldDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'upperLimit',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.upperLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'lowerLimit',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.lowerLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdFieldOpcConfig.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdFieldOpcConfig, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
